﻿/**
 * group-modal.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('group-modal.controller', groupModalController);

	/** setup injection */
	groupModalController.$inject = ['$uibModalInstance', '$timeout', 'toastr', 'portal-link-group.repository', 'portal-link-group-link.repository', 'portal-link.repository', 'color.repository', 'portalGroup', 'parentInit'];

	/** implementation */
	function groupModalController($uibModalInstance, $timeout, toastr, portalLinkGroupRepo, portalLinkGroupLinkRepo, portalLinkRepository, colorRepo, portalGroup, parentInit) {
		/** pubic properties */
		var vm = this;
		vm.saving = false;
		vm.isNew = portalGroup ? false : true;
		vm.original = portalGroup || createPortalLinkGroup();
		vm.portalGroup = angular.copy(vm.original);
		vm.tab = 'group-info-tab';
		vm.groupLinks = [];
		vm.colors = [];
		vm.searching = false;
		vm.searchString = '';
		vm.searchResults = [];

		/** public methods */
		vm.save = save;
		vm.activate = activate;
		vm.remove = remove;
		vm.reorder = reorder;
		vm.searchLinks = searchLinks;
		vm.addLink = addLink;
		vm.removeLink = removeLink;
		vm.closeSearch = closeSearch;
		vm.close = close;
		vm.cancel = cancel;

		/** run init */
		init();

		/** public method implementations */

		/** save the group */
		function save() {
			/** flip saving flag */
			vm.saving = true;

			/** map values from source to original */
			_.merge(vm.original, vm.portalGroup);

			/** send the request to activate/deactivate */
			portalLinkGroupRepo.save(vm.original, (vm.original.portalLinkGroupID !== 0 ? vm.original.portalLinkGroupID : undefined)).then(function(portalLinkGroup) {
				/** show the success message */
				swal({
					'title': 'Save Complete',
					'text': 'The processing has completed. The group was saved successfully.',
					'type': 'success'
				}, function() {
					/** flip saving flag */
					vm.saving = false;

					/** set isNew to false */
					vm.isNew = false;

					/** set original and copy */
					if (portalLinkGroup) {
						vm.original = portalLinkGroup;
						vm.portalGroup = angular.copy(vm.original);
					}

					/** load group links */
					loadLinks();

					/** reset the users groups */
					portalLinkGroupRepo.resetGroups();

					/** reinitialize the parent */
					parentInit();
				});
			});
		}

		/** activate/deactivate a group */
		function activate(active) {
			/** set the isEnabled flag */
			vm.original.isEnabled = active;

			/** flip saving flag */
			vm.saving = true;

			/** send the request to activate/deactivate */
			portalLinkGroupRepo.put(vm.original, vm.original.portalLinkGroupID).then(function() {
				/** flip the isEnabled flag on the copy */
				vm.portalGroup.isEnabled = vm.original.isEnabled;

				/** flip saving flag */
				vm.saving = false;

				/** show the success message */
				swal({
					'title': 'Save Complete',
					'text': 'The processing has completed. The group was saved successfully.',
					'type': 'success'
				}, function() {
					/** reset the users groups */
					portalLinkGroupRepo.resetGroups();

					/** reinitialize the parent */
					parentInit();
				});
			});
		}

		/** remove the group */
		function remove() {
			/** show swal confirmation window */
			swal({
				'title': 'Are you sure you want to delete this group?',
				'type': 'warning',
				'showCancelButton': true,
				'confirmButtonText': 'Yes, Delete It!',
				'closeOnConfirm': false
			}, function(isConfirm) {
				/** check the isConfirm flag */
				if (isConfirm) {
					/** flip saving flag */
					vm.saving = true;

					/** send the request to activate/deactivate */
					portalLinkGroupRepo.remove(portalGroup.portalLinkGroupID).then(function() {
						/** flip saving flag */
						vm.saving = false;

						/** show the success message */
						swal({
							'title': 'Delete Complete',
							'text': 'The processing has completed. The group was deleted successfully.',
							'type': 'success'
						}, function() {
							/** reset the users groups */
							portalLinkGroupRepo.resetGroups();

							/** reinitialize the parent */
							parentInit();

							/** close modal */
							close();
						});
					});
				}
			});
		}

		/** reorder the related links */
		function reorder() {
			/** set the order number value */
			angular.forEach(vm.groupLinks, function(gl, index) {
				gl.orderNumber = (index + 1);
			});

			/** save groups */
			portalLinkGroupLinkRepo.reorder(vm.groupLinks).then(function() {
				/** show success message */
				toastr.success('Group Links reordered successfully.', 'Save Successful', { positionClass: 'toast-bottom-right' });
			});
		}

		/** search for links */
		function searchLinks() {
			/** reset matches */
			vm.searchResults = [];

			/** check the length */
			if (vm.searchString.length < 2) return;

			/** place search in timeout so that old results don't still display */
			$timeout(function() {
				/** flip searching flag */
				vm.searching = true;

				/** load portal links */
				portalLinkRepository.search(vm.searchString).then(function(matches) {
					/** set search results */
					vm.searchResults = matches;

					/** set the active flag */
					toggleSearchResults();

					/** flip searching flag */
					vm.searching = false;
				});
			}, 100);
		}

		/** add the portal link */
		function addLink(portalLinkID) {
			/** flip saving flag */
			vm.saving = true;

			/** get the order number */
			var orderNumber = 0;
			var lastGroupLink = _.last(vm.groupLinks);
			if (lastGroupLink !== undefined) {
				orderNumber = lastGroupLink.orderNumber + 1;
			}

			/** create the object */
			var portalLinkGroupLink = {
				'portalLinkGroupLinkID': 0,
				'portalLinkID': portalLinkID,
				'portalLinkGroupID': vm.portalGroup.portalLinkGroupID,
				'orderNumber': orderNumber
			};

			/** send the request to activate/deactivate */
			portalLinkGroupLinkRepo.post(portalLinkGroupLink).then(function() {
				/** flip saving flag */
				vm.saving = false;

				/** show success message */
				toastr.success('Group Link added successfully.', 'Add Successful', { positionClass: 'toast-bottom-right' });

				/** reload the links */
				loadLinks();
			});
		}

		/** remove the portal link */
		function removeLink(portalLinkGroupLinkID) {
			/** flip saving flag */
			vm.saving = true;

			/** send the request to activate/deactivate */
			portalLinkGroupLinkRepo.remove(portalLinkGroupLinkID).then(function() {
				/** flip saving flag */
				vm.saving = false;

				/** show success message */
				toastr.success('Group Link removed successfully.', 'Delete Successful', { positionClass: 'toast-bottom-right' });

				/** reload the links */
				loadLinks();
			});
		}

		/** close the search results */
		function closeSearch() {
			/** reset values */
			vm.searchString = '';
			vm.searchResults = [];
		}

		/** close the modal */
		function close() {
			$uibModalInstance.close();
		}

		/** cancel the modal */
		function cancel() {
			$uibModalInstance.dismiss();
		}

		/** private methods */

		/** initialize */
		function init() {
			/** check for group */
			if (!vm.isNew) {
				/** load group links */
				loadLinks();
			}

			/** load the possible colors */
			colorRepo.getAll().then(function(colors) {
				/** set the colors */
				vm.colors = colors;
			});

			/** set focus on the */
			$uibModalInstance.rendered.then(function() {
				$('.modal-body div input[type="text"]:first').focus();
			});
		}

		/** load the related portal links */
		function loadLinks() {
			/** load group links */
			portalLinkGroupLinkRepo.getForGroup(vm.portalGroup.portalLinkGroupID).then(function(portalLinkGroupLinks) {
				/** set the group links */
				vm.groupLinks = portalLinkGroupLinks;

				/** set the active flag */
				toggleSearchResults();
			});
		}

		/** toggle the active flag on search results */
		function toggleSearchResults() {
			/** add active flag */
			_.forEach(vm.searchResults, function(sr) {
				sr.active = vm.groupLinks.filter(function(gl){ return gl.portalLinkID === sr.portalLinkID; }).length === 0;
			});
		}

		/** create an empty PortalLinkGroup entity */
		function createPortalLinkGroup() {
			return {
				'portalLinkGroupID': 0,
				'portalLinkGroupName': 'New Group',
				'description': 'Your description should go here.',
				'orderNumber': 0,
				'isEnabled': false,
				'isRemoveable': true,
				'iconColor': '#7A8599',
				'iconClass': 'nha-portal'
			};
		}
	}
})();